import React from 'react';
import Link from 'next/link';
import ArticleSvg from 'pubweb-smokey/dist/images/svg/iconography-16x16/article.svg';
import BriefcaseSvg from 'pubweb-smokey/dist/images/svg/iconography-16x16/briefcase.svg';
import LocationLineSvg from 'pubweb-smokey/dist/images/svg/iconography-16x16/location-line.svg';

import { pushGTMEvent } from 'pubweb-smokey/dist/utils/analytics';

import { getCareerSiteUrl } from '@utils/config';

import { SubHeaderStyles } from './Subheader.styled';

const SubHeader = () => {
  return (
    <SubHeaderStyles>
      <a
        href={getCareerSiteUrl()}
        className="gtm-careers-website"
        target="_blank"
        rel="noopener noreferrer"
      >
        <BriefcaseSvg viewBox="0 0 16 16" alt="Careers Link" />
        <span>Careers</span>
      </a>
      <Link href="/newsroom/" className="gtm-newsroom">
        <ArticleSvg viewBox="0 0 16 16" alt="Newsroom Link" />
        <span>Newsroom</span>
      </Link>
      <Link
        href="/locations/"
        onClick={() => pushGTMEvent('findARetailerClick')}
      >
        <LocationLineSvg viewBox="0 0 16 16" alt="Find A Retailer Link" />
        <span>Find A Retailer</span>
      </Link>
    </SubHeaderStyles>
  );
};

export default SubHeader;
